<template>
  <div class="nav-header-h5">
    <el-menu :default-active="activeIndex" class="nav-menu" :class="[style]" mode="horizontal">
      <el-menu-item index="0" disabled>
        <img class="josh-logo" src="@/assets/public/logo.png">
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import lang from '@/options/lang'
export default {
  data () {
    return {
      activeIndex: this.index,
      activeLang: '',
      lang: lang,
      username: null,
      style: this.className
    }
  },
  props: {
    index: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    }
  },
  created() {
    
  },
  methods: {
    
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '@/css/style.scss';
$font-color: #909399;
.nav-header-h5 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  border-top: 4px solid $color-blue;
  border-bottom: solid 1px #e6e6e6;
  z-index: 9;
  .nav-menu {
    display: block;
    padding: 0 30px;
    margin: 0 auto;
  }
  .el-menu-item.is-disabled {
    opacity: 1!important;
  }
  .el-menu-item {
    padding: 0;
    height: 80px;
    line-height: 80px;
  }
  .josh-logo {
    height: 48px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/H5/components/NavBar.vue